export const ALERT_STATUS = {
  REJECTED: 0,
  ACTIVE: 1,
  RESOLVED: 2,
};
